import * as React from "react";
import { Button, Tooltip } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { CardContent } from "../../../components/antd/card/CardContent";
import { v4 as uuidv4 } from "uuid";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpArrayObject } from "../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemDictionary } from "./CpArrayItemDictionary";
import { ImportButton, keyValueTransformer, KeyValueItem } from "../../../components/import";

interface Props {}
export const SecretDataDictionary: React.FC<Props> = ({}) => {
  const { id: formId } = useCpFormContext();
  const items = useCpFormValue(`dictionary`) as (KeyValueItem & { isVisible?: boolean })[];
  const isEdit = useCpFormValue(`meta.isEdit`);

  const allVisible = items?.length > 0 && items.every((item) => item.isVisible !== false);
  const toggleAll = () => {
    if (!items) return;
    const newValue = !allVisible;
    const updated = items.map((item) => ({ ...item, isVisible: newValue }));
    formSetValue(formId, "dictionary", updated);
  };

  return (
    <>
      <CardContent>
        <div className="flex items-center gap-4 mb-2">
          <div>Dictionary Secret Data</div>
          <ImportButton<KeyValueItem[], KeyValueItem[]>
            formId={formId}
            fieldName="dictionary"
            actionLabel="Import dictionary secret"
            existingValue={items}
            transform={(parsed, existing) =>
              keyValueTransformer(parsed, existing, {
                generateId: () => uuidv4(),
                stringify: true,
              })
            }
            explanation={
              <div className="text-xs">
                <div className="font-semibold mb-1">Supported formats:</div>
                <div><strong>.env</strong> — KEY=value</div>
                <div><strong>.yaml</strong> — key: value</div>
                <div><strong>.json</strong> — {`{"key": "value"}`}</div>
                <div className="mt-1 opacity-75">Also supports Kubernetes Secret format</div>
              </div>
            }
          />
          {isEdit && items?.length > 0 && (
            <Tooltip title={allVisible ? "Hide all values" : "Show all values"}>
              <Button
                size="small"
                icon={allVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                onClick={toggleAll}
              />
            </Tooltip>
          )}
        </div>
        <CpArrayObject
          name="dictionary"
          factoryFn={() => ({ id: uuidv4(), name: "", value: "", isVisible: true })}
          labels={["Key", "Value"]}
        >
          <CpArrayItemDictionary />
        </CpArrayObject>
      </CardContent>
    </>
  );
};
